import { reduxForm } from 'redux-form';
import Component from './FormUploadstockMerchant';
import { validate, initialValues } from './schema';

const FormUploadstockMerchant = reduxForm({
  form: 'formUploadstockMerchant',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FormUploadstockMerchant;
